import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Form as BootstrapForm } from "react-bootstrap";
import formatCnpj from "@brazilian-utils/format-cnpj";
import CheckBox from "~/components/layout/CheckBoxCustom";
import CloseIcon from "@material-ui/icons/ContactsOutlined";
import HomeIcon from "@material-ui/icons/Home";
import OpenChatBot from '~/components/layout/Chatbot';

import {
  Background,
  MainContainer,
  Title,
  Textfield,
  ErrorMessage,
  Label,
  LightLabel,
  NextButton,
  CheckBoxScrollList,
  CheckBoxList,
  PhoneInput,
  CloseButton,
  HeaderContainer,
  HeaderContent
} from "./styles";
import "~/components/styles/Global.css";
import api from "~/services/api";
import HeaderMobile from "~/components/layout/HeaderOld";
import Loading from "~/components/layout/Loading";

export default function Employee({ desktop, onCloseClick }) {
  const dispatch = useDispatch();
  const history = useHistory();

  const [loadingPage, setLoadingPage] = useState(true);
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [stores, setStores] = useState([]);

  const economicGroupReducer = useSelector(
    (state) => state.economicGroupReducer
  );

  const [phoneMaskManipulator, setPhoneMaskManipulator] = useState("(99) 9999-9999");
  const [btnRegisterVisible, setBtnRegisterVisible] = useState(false);

  const getStores  = () => {

    if(economicGroupReducer.stores){

      if(economicGroupReducer.stores.length > 0 && stores.length === 0){
        let storesList = economicGroupReducer.stores;
        storesList = storesList.map((store) => {
          store.checked = false;
          return store;
        });
        setStores(storesList);
      }
    }
  }

  useEffect(() => {
    getStores();
  }, [economicGroupReducer.stores]);

  const getRoles = () => {
    const header = {
      "Content-Type": "application/json",
      access_token: localStorage.getItem("access_token"),
    };
    const parameters = {
      method: "GET",
      headers: header,
    };
    const url = `/residential/store/v1/roles?_limit=100`;

    api
      .get(url, parameters)
      .then((res) => {
        let rolesList = [];
        rolesList = res.data;
        const isAuthorizedCoreVisit = localStorage.getItem('isAuthorizedCoreVisit') === 'true';
        rolesList = rolesList.map((role) => {
          role.checked = false;
          role.nameFiltered = filterRoleName(role.name);
          if (role.name === 'CONSULTOR_COMERCIAL' && isAuthorizedCoreVisit) {
            role.nameFiltered = 'Histórico de visitas';
          }
          return role;
        });
        setRoles(rolesList);
      })
      .catch((err) => {
        const erro = err.response;
        if (erro) {
          const message = err.response.data.message;
          if (erro.status !== 401) {
            toast.error(message);
          }
        } else {
          if (err.response.status !== 401) {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        }
      });
  }

  useEffect(() => {

    if(stores.length > 1 || roles.length > 1) {
      setLoadingPage(false);
    }

  }, [stores, roles]);

  const filterRoleName = (roleName) => {
    switch (roleName) {
      case "BOLETOS": {
        return "Boletos";
      }
      case "HUB": {
        return "HUB";
      }
      case "MARKETING": {
        return "Marketing";
      }
      case "NOTAS_FISCAIS": {
        return "Notas Fiscais";
      }
      case "PEDIDO_DE_ABASTECIMENTO": {
        return "Pedido de Abastecimento";
      }
      case "STATUS_DO_PEDIDO": {
        return "Status do Pedido";
      }
      case "TREINAMENTOS": {
        return "Treinamentos";
      }
      case "VALE_GAS": {
        return "Vale Gás";
      }
      case "CONTRATOS": {
        return "Contratos";
      }
      case "DESAFIO_LAPIDAR": {
        return "Desafio Lapidar";
      }
      case 'TROCAS': {
        return 'Trocas';
      }
      case 'CONSULTOR_COMERCIAL': {
        return 'Consultor comercial'
      }
      default: {
        return roleName;
      }
    }
  };

  useEffect(() => {
    if(!localStorage.getItem('ownerid') ){
      getRoles();
      getStores();
    }
    else
    { history.push("/"); }
  }, []);

  const handleCheckbox = (arrayItem, arrayTarget) => {
    if(arrayTarget == "stores") {
      const newStores = stores.map((item) => {
      if (item.storeId === arrayItem.storeId) {
          item.checked = !item.checked
      }
      return item;
      });
      setStores(newStores);
    }

    if(arrayTarget == "roles")
    {
      const newRoles = roles.map((item) => {
        if(item.name === arrayItem.name)
        { item.checked = !item.checked }
        return item;
      });
      setRoles(newRoles);
    }

    if( onlySelectedRoles(roles).length < 1 ||
      onlySelectedStores(stores).length < 1 )
    {  setBtnRegisterVisible(false); }
    else
    {  setBtnRegisterVisible(true); }
  }

  const SignUpSchema = Yup.object().shape({
    name: Yup.string()
    .required("Preencha o Nome"),
    phone: Yup.string()
    .required("Insira o celular"),
    mail: Yup.string()
    .email('Insira um e-mail válido')
    .required('Preencha o e-mail'),
  });

  const validatePhone = value => {
    let error;
    value = value.split("_").join("");
    value = value.split(" ").join("");
    value = value.split("-").join("");
    value = value.split("(").join("");
    value = value.split(")").join("");
    if (!value) {
      error = "Insira o celular";
    }
    if (!/[^\d-.\/]/.test(value)) {
      const numbers = value.replace(/[^\d]/g, "");
      if (numbers.length > 0 && numbers.length < 10) {
        error = "Insira um celular válido";
      }
    }
    return error;
  };

  const formSubmit = (values) => {
    setLoading(true);

    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };

    const parameters = {
      method: 'POST',
      headers: header,
    };

    const url = `/residential/store/v1/users?login=${values.mail}`;

    api
    .get(url, parameters)
    .then((res) => {
      if(res.data.length < 1)
      { registerEmployee(values); }
      else
      {
        setLoading(false);
        toast.error("Esse usuário já possui cadastro");
      }
    })
    .catch((err) => {
      setLoading(false);
      const erro = err.response;
      if (erro) {
        const message = err.response.data.message;
        if (erro.status !== 401) {
          toast.error(message);
        }
      } else {
        if (err.response.status !== 401) {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      }
    });

  }

  const registerEmployee = (values) => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };

    const parameters = {
      method: 'POST',
      headers: header,
    };

    const body = {
      name: values.name,
      login: values.mail,
      phone: values.phone.replace(/[^0-9.]/g, ""),
      roles: onlySelectedRoles(roles),
      stores : onlySelectedStores(stores)
    };

    const url = `/residential/store/v1/users/${localStorage.getItem('userId')}/employees`;

    api
    .post(url, body, parameters)
    .then((res) => {
      if (res.status === 201) {
        getContactId(res.headers.location);
      }
    })
    .catch((err) => {
      setLoading(false);
      const erro = err.response;
      if (erro) {
        const message = err.response.data.message;
        if (erro.status !== 401) {
          toast.error(message);
        }
      } else {
        if (err.response.status !== 401) {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      }
    });
  }

  const getContactId = (location) => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };

    const parameters = {
      method: 'GET',
      headers: header,
    };

    const url = `${location}/contacts?contact-type=EMAIL`;

    api
    .get(url, parameters)
    .then((res) => {
      if(res.data.length > 0)
      { sendToken(location, res.data[0].contactId); }
    })
    .catch((err) => {
      setLoading(false);
      const erro = err.response;
      if (erro) {
        const message = err.response.data.message;
        if (erro.status !== 401) {
          toast.error(message);
        }
      } else {
        if (err.response.status !== 401) {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      }
    });

  }

  const sendToken = (location, contactId) => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };

    const parameters = {
      method: 'POST',
      headers: header,
    };
    const body = {
      tokenType: "REGISTER",
      contactId: contactId,
      url: process.env.REACT_APP_URL + "senha-funcionario",
    };

    const url = `${location}/tokens`;

    api
    .post(url, body, parameters)
    .then((res) => {
      setLoading(false);
      toast.success('Cadastro realizado com sucesso');
      backPage();
    })
    .catch((err) => {
      setLoading(false);
      const erro = err.response;
      if (erro) {
        const message = err.response.data.message;
        if (erro.status !== 401) {
          toast.error(message);
        }
      } else {
        if (err.response.status !== 401) {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      }
    });
  }

  const onlySelectedRoles = (list) => {
    return list
    .filter((item) => {
      if(item.checked === true)
      { return true; }
      else
      { return false; }
    })
    .map((item) => {
      return { name : item.name };
    });
  }

  const onlySelectedStores = (list) => {
    return list
    .filter((item) => {
      if(item.checked === true)
      { return true; }
      else
      { return false }
    })
    .map((item) => {
      return {
      storeId : item.storeId,
      name : item.name };
    });
  }

  const handlePhoneMaskManipulator = (phoneValue) => {
    if(phoneValue.target.value.length > 14)
    { setPhoneMaskManipulator("(99) ?9999-9999"); }
    else
    { setPhoneMaskManipulator("(99) 9999-9999?"); }
  }

  const backPage = () =>{
    dispatch({
      type: "ACTIVE_EMPLOYEE_MODAL",
      activeModal: { employee: false, modal: false }
    });
    history.push("/portal");
  }

  const HeaderComponent = () => (
    <>
      <HeaderMobile />
    </>
  );

  return (
    <>
      <Background>
        {loadingPage ? (
          <Loading />
        ) : (
          <MainContainer onClick={(e) => e.stopPropagation()}>
            <HeaderContainer>
              <HeaderContent>
                <HomeIcon />
                <span>{localStorage.getItem('storeName')} - {formatCnpj(localStorage.getItem('storeDocument'))}</span>
              </HeaderContent>
              <CloseButton onClick={onCloseClick || backPage}>✕</CloseButton>
            </HeaderContainer>

            <Title>
              <CloseIcon fontSize="large"/>
              Cadastrar Usuários
            </Title>
            <Formik
              initialValues={{ name: "", mail: "", phone: "" }}
              validationSchema={SignUpSchema}
              onSubmit={(values) => {
                formSubmit(values);
              }}
            >
              {({ handleChange, handleBlur, values, errors, touched }) => (
              <Form autocomplete="off">
                  <BootstrapForm.Group controlId="name">
                    <Label>Nome completo</Label>
                    <Field
                      render={({ field }) => {
                        return (
                          <Textfield
                            id="name"
                            type="text"
                            label="Nome completo"
                            arial-label="Nome completo"
                            aria-required
                            errorCondition={errors.name && touched.name}
                            errorMessage={errors.name}
                            title="Nome completo"
                            onBlur={handleBlur}
                            placeholder="Nome completo"
                            value={values.name}
                            onChange={handleChange}
                          />
                        );
                      }}
                      name="name"
                    />
                    {errors.name && touched.name ? (
                      <ErrorMessage>{errors.name}</ErrorMessage>
                    ) : null }
                  </BootstrapForm.Group>
                  <BootstrapForm.Group controlId="mail">
                    <Label>E-mail</Label>
                    <Field
                      render={({ field }) => {
                        return (
                          <Textfield
                            id="mail"
                            type="text"
                            label="E-mail"
                            arial-label="E-mail"
                            aria-required
                            errorCondition={errors.mail && touched.mail}
                            errorMessage={errors.mail}
                            title="E-mail"
                            onBlur={handleBlur}
                            placeholder="E-mail"
                            value={values.mail}
                            onChange={handleChange}
                          />
                        );
                      }}
                      name="mail"
                    />
                    {errors.mail && touched.mail ? (
                      <ErrorMessage>{errors.mail}</ErrorMessage>
                    ) : null}
                  </BootstrapForm.Group>
                  <BootstrapForm.Group controlId="phone">
                    <Label>Celular</Label>
                    <Field
                      render={({ field }) => {
                        return (
                          <PhoneInput
                            id="phone"
                            mask={phoneMaskManipulator}
                            maskChar={null}
                            formatChars={{ "9": "[0-9]", "?": "[0-9]" }}
                            className="inputPhone"
                            type="text"
                            label="Celular"
                            arial-label="Celular"
                            aria-required
                            errorCondition={errors.phone && touched.phone}
                            errorMessage={errors.phone}
                            title="Celular"
                            onBlur={handleBlur}
                            placeholder="Celular"
                            value={values.phone}
                            onChange={(e) => { handleChange(e);handlePhoneMaskManipulator(e);}}
                          />
                        );
                      }}
                      validate={validatePhone}
                      name="phone"
                    />
                    {errors.phone && touched.phone ? (
                      <ErrorMessage>{errors.phone}</ErrorMessage>
                    ) : null}
                  </BootstrapForm.Group>
                  <BootstrapForm.Group
                    controlId="revendas"
                    className="checkboxGroup">
                    <LightLabel>Atribuir revenda</LightLabel>
                    <CheckBoxScrollList>
                      { stores.map((store) => (
                        <CheckBox
                          name={store.name}
                          label={`${store.name} - ${formatCnpj(store.storeDocument)}`}
                          title={`${store.name} - ${formatCnpj(store.storeDocument)}`}
                          checked={store.checked}
                          onChange={() => handleCheckbox(store, "stores")}
                        />
                      ))}
                    </CheckBoxScrollList>
                  </BootstrapForm.Group>
                  <BootstrapForm.Group
                    controlId="acessroles"
                    className="checkboxGroup">
                    <LightLabel>Permissões de acesso</LightLabel>
                    <CheckBoxList>
                      { roles.map((role) => (
                        <CheckBox
                          name={role.nameFiltered}
                          label={role.nameFiltered}
                          title={`${role.nameFiltered} - ${role.description}`}
                          checked={role.checked}
                          columns={2}
                          onChange={() => handleCheckbox(role, "roles")}
                        />
                      ))}
                    </CheckBoxList>
                  </BootstrapForm.Group>
                  <NextButton type="submit" className="mt-4" disabled={ loading || !btnRegisterVisible ? true : false}>
                    {loading ? (
                      <i
                        className="fa fa-spinner fa-pulse fa-3x fa-fw"
                        style={{ fontSize: "1.3rem" }}
                      />
                    ) : (
                      <>
                        <span>Cadastrar</span>
                      </>
                    )}
                  </NextButton>
                </Form>
              )}
            </Formik>
          </MainContainer>
        )}
      </Background>
      <OpenChatBot />
    </>
  );
}
